module.exports = __webpack_public_path__ + "img/Chipped Girdle.d7104f4f.png";